module.exports = __webpack_public_path__ + "img/matrix.76c780e6.png";